<template>
  <iframe class="my-frame" ref="iframe" src="/static/gantt/index.html" :name="iframeName" @load="onIframeLoad"></iframe>
</template>

<script>
export default {
  name: 'IframeGantt',
  props: {
    src: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      iframeName: `iframe-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`, // 生成唯一标识符
      frameLoaded: false,
      ganttData:{},
      selectedData:{}
    }
  },
  mounted() {
    // 在 iframe 加载完成后发送任务数据
    this.$refs.iframe.onload = () => {
      this.frameLoaded = true;
    };

    this.postDataToIframe();
    window.addEventListener('resize', this.resizeIframe);
    window.addEventListener('message', this.handleMessage);
  },
  updated() {
    this.postDataToIframe();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeIframe);
  },
  methods: {
    getSelectedData(){
      return this.selectedData;
    },
    onIframeLoad() {
      this.resizeIframe();
    },
    resizeIframe() {
      const iframe = this.$refs.iframe;
      if (iframe) {
        const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
        const ganttDiv = iframeDocument.getElementById('gantt_div');
        if (ganttDiv) {
          //设置100%不起作用
          //ganttDiv.style.width = '100%';
          //ganttDiv.style.height = '100%';
          const parentWidth = iframe.offsetWidth;
          const parentHeight = iframe.offsetHeight;
          ganttDiv.style.width = `${parentWidth - 20}px`;
          ganttDiv.style.height = `${parentHeight - 20}px`;
        }
      }
    },
    refresh(config, tasks) {
      // 接收来自 iframe 的消息
      console.log('refresh gantt, tasks:', tasks);

      this.ganttData = {
        tasks: tasks,
        config: config
      };

      if(this.frameLoaded){
        this.postDataToIframe();
      }else{
        //如果 iframe 还没有加载完成，则延迟发送数据
        setTimeout(() => {
          this.postDataToIframe();
        }, 100);
      }
    },
    postDataToIframe() {
      try {
        // 深度克隆数据以确保可序列化
        const safeData = JSON.parse(JSON.stringify(this.ganttData));
        this.$refs.iframe.contentWindow.postMessage(safeData, '*');
      } catch (error) {
        console.error("Failed to serialize data for postMessage:", error);
      }
    },
    handleMessage(event) {
      if (!this.$refs.iframe) return;

      // 检查消息来源是否为 iframe
      if (event.source !== this.$refs.iframe.contentWindow) return;

      // 处理接收到的数据
      this.selectedData = event.data;
      console.log('iframeGantt selectedData:', this.selectedData);
    }
  }
};
</script>

<style scoped>

.my-frame{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  min-height: 400px;
  border: none; /* 可选：移除 iframe 的边框 */
}

</style>

